import { FC, ReactNode } from 'react';
import styles from './index.style.module.css';
import {
  headingWithLinesPrefix,
  subHeadingPrefix,
  spacer,
} from '../../../utils/apiResponseTransformers';

type MarkdownComponentProps = {
  children: ReactNode;
  className?: string;
};

type MarkdownConfig = {
  [key: string]: (props: MarkdownComponentProps) => JSX.Element | ReactNode;
};

const HeadingWithLines: FC<MarkdownComponentProps> = ({ children }) => {
  return (
    <div className={styles.markdown__heading__with__lines}>
      <div className={styles.markdown__heading__line} />
      <div className={styles.markdown__heading__text}>
        <h1 className='tab-accessible' tabIndex={0}>
          {children}
        </h1>
      </div>
      <div className={styles.markdown__heading__line} />
    </div>
  );
};

const markdownConfig: MarkdownConfig = {
  h1: ({ children }) => (
    <h1 className={`${styles.markdown__heading1}  tab-accessible`} tabIndex={0}>
      {children}
    </h1>
  ),
  h2: ({ children }) => (
    <h2 className={`${styles.markdown__heading2}  tab-accessible`} tabIndex={0}>
      {children}
    </h2>
  ),
  p: ({ children }) => {
    if (Array.isArray(children) && typeof children[0] === 'string') {
      const text = children[0];
      if (text.startsWith(headingWithLinesPrefix))
        return (
          <HeadingWithLines>
            {text.slice(headingWithLinesPrefix.length)}
          </HeadingWithLines>
        );
      if (text.startsWith(subHeadingPrefix))
        return (
          <h2
            className={`${styles.markdown__subheading}  tab-accessible`}
            tabIndex={0}
          >
            {text.slice(subHeadingPrefix.length)}
          </h2>
        );
      if (text.startsWith(spacer)) return <div className={styles.spacer} />;
    }
    return (
      <p
        className={`${styles.markdown__paragraph}  tab-accessible`}
        tabIndex={0}
      >
        {children}
      </p>
    );
  },
  strong: ({ children }) => (
    <strong className={styles.markdown__strong}>{children}</strong>
  ),
  sup: ({ children }) => <sup className={styles.markdown__sup}>{children}</sup>,
  ul: ({ children }) => <ul className={styles.markdown__ul}>{children}</ul>,
  ol: ({ children }) => <ol className={styles.markdown__ol}>{children}</ol>,
  li: ({ children }) => <li className={styles.markdown__li}>{children}</li>,
  pre: ({ children }) => <pre className={styles.markdown__pre}>{children}</pre>,
};

export default markdownConfig;
